module.exports = __webpack_public_path__ + "img/i_ar_main_sec_bl.76d1a337.svg";